import React, { useEffect, useState } from "react";
import { getOrCreateGuid } from "../utils/guid";
import PlayerList from "../components/PlayerListStorage";
import NewGame from "../components/NewGame";
import Button from "../components/ui/button";
import ClipLoader from "react-spinners/ClipLoader";
import {FaDownload } from "react-icons/fa";

const Game = () => {
  const [game, setGame] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  
  useEffect(() => {
    const savedGame = localStorage.getItem("score3cnoteData");
    if (savedGame) {
      setGame(JSON.parse(savedGame)); 
    } else {
      const initialGame = {
        id: null,
        players: [],
        name: "game_" + Date.now(),
        coefficient: 5,
        timestamp: Date.now(),
      };
      setGame(initialGame); 
    }
    setLoading(false);
  }, []);

  const handleNewGame = () => {
    setShowConfirmModal(true); 
  };

  const confirmNewGame = async () => {
    try {
      // Cập nhật lại game state trước khi xóa localStorage
      const newGame = {
        id: null,
        players: [],
        name: "game_" + Date.now(),
        coefficient: 5,
        timestamp: Date.now(),
      };

      // Cập nhật game vào state (React sẽ render lại ngay lập tức)
      setGame(newGame); // Cập nhật lại game state

      // Sau đó, xóa dữ liệu trong localStorage
      localStorage.clear();

      // Lưu game mới vào localStorage
      localStorage.setItem("score3cnoteData", JSON.stringify(newGame));

      setShowConfirmModal(false); // Đóng modal sau khi tạo game mới
    } catch (error) {
      console.error("Failed to create new game", error);
      setShowConfirmModal(false); // Đóng modal khi có lỗi
    }
  };

  const cancelNewGame = () => {
    setShowConfirmModal(false); // Hủy bỏ việc tạo game mới
  };
  const formatDate = (timestamp) => {
    const date = new Date(timestamp); // Convert timestamp to Date object
    const day = String(date.getDate()).padStart(2, '0'); // Day with leading zero
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month with leading zero (Month is 0-indexed)
    const year = date.getFullYear(); // Year
  
    return `${day}/${month}/${year}`;
  };
  // Convert players list to CSV format
  const convertToCSV = (players) => {
    const headers = ["ID", "Name", "Score", "Time"];
    const timeGame = game && game.timestamp ? formatDate(game.timestamp):'2025';
    const rows = players.map(player => [
      player.id,
      player.name,
      player.score,
      timeGame
    ]);

    // Create CSV content
    const csvContent = [
      headers.join(","),
      ...rows.map(row => row.join(","))
    ].join("\n");

    return csvContent;
  };

  // Trigger CSV download
  const handleExportCSV = () => {
    const csvContent = convertToCSV(game.players);
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const fileName = `player_list_${new Date().toISOString()}.csv`;
      link.setAttribute("href", URL.createObjectURL(blob));
      link.setAttribute("download", fileName);
      link.click();
    }
  };

  if (loading) return <ClipLoader color="#ffffff" loading size={50} />; // Hiển thị loader khi đang tải dữ liệu

  return (
    <div className="p-4 max-w-md mx-auto bg-white shadow-md rounded-lg">
      {game ? (
        <>
        <div className="flex justify-center items-center space-x-4 btn-head-games">
          <NewGame onCreate={handleNewGame} timeCreate={game.timestamp} /> 
          {/* Export CSV Button */}
          {/* {game.players && game.players.length > 0 &&
          (
                <Button onClick={handleExportCSV} className="export-csv-button bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 text-lg rounded-lg shadow-lg flex items-center">
                    <FaDownload size={18} className="mr-2" />
                </Button>
            )} */}
        </div>
          <PlayerList game={game} setGame={setGame} /> {/* Truyền game và setGame xuống PlayerList */}
          {showConfirmModal && (
            <div className="modal-overlay">
              <div className="modal-content">
                <h3 className="modal-title">Xác nhận</h3>
                <p>Đang có trận đấu, đảm bảo rằng bạn đã chụp ảnh lưu lại kết quả và tạo game mới?</p>
                <div className="flex justify-between space-x-4">
                  <Button onClick={confirmNewGame} className="confirm-button bg-red-500 text-white">
                    Xác Nhận
                  </Button>
                  <Button onClick={cancelNewGame} className="cancel-button bg-gray-500 text-white">
                    Hủy
                  </Button>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <NewGame onCreate={handleNewGame} timeCreate={game.timestamp} /> // Nếu chưa có game, hiển thị NewGame
      )}
    </div>
  );
};

export default Game;
